/*
 * @Descripttion: 官网物料调价页面相关数据
 * @Author: 曹博
 * @Date: 2023-10-24 09:33:27
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-03 09:17:45
 */

import { GwProductItem } from '../../api/InventoryManagementApi'
import { ActionType, CustomAction } from '../../global'

// 当前执行调价操作的物料
export interface CurrentProduct {
  id: string
  code: string
  name: string
  brandName: string
  manuCode: string
  gwProductSerialNumber: string
  orderRate: string
  highestChangePrice: string
}

// 进度条状态数据
export const progressItemStatusList = [
  {
    state: 'loading', // 当前步骤所对应的接口正在请求中
    des: '进行中...',
    color: '#FF7401',
  },
  {
    state: 'error',
    des: '失败，请关闭弹窗后重试', // 接口请求报错
    color: '#F5222D',
  },
  {
    state: '', // 接口请求成功/未执行到该步骤，不展示标签
    des: '',
    color: '',
  },
] as const
export type ProgressItemStatus =
  (typeof progressItemStatusList)[number]['state']
// 进度条数据类型
export interface ProgressItem {
  title: string
  status: ProgressItemStatus
}

export interface State {
  dataSource: {
    data: GwProductItem[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
  isPriceAdjustmentModalOpen: boolean // 调价弹窗显隐
  isDefinition: boolean // 是否为自定义调价
  submitApplyFlag: boolean // 是否展示步骤条结果页
  currentStep: number // 当前所处步骤
  currentApplyProductMainInfo: CurrentProduct // 当前调价物料
  progressList: ProgressItem[] // 步骤条数据
  isPriceAdjustConfirmBtnLoading: boolean // 弹窗提交按钮loading状态
  hasRules: boolean
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 0,
  },
  loading: true,
  searchData: {},
  pages: {
    pageNo: 1,
    pageSize: 10,
  },
  isPriceAdjustmentModalOpen: false,
  isDefinition: false,
  submitApplyFlag: false,
  currentStep: 0,
  currentApplyProductMainInfo: {
    id: '',
    code: '',
    name: '',
    brandName: '',
    manuCode: '',
    gwProductSerialNumber: '',
    orderRate: '',
    highestChangePrice: '',
  },
  progressList: [
    {
      title: '获取价格参数',
      status: 'loading',
    },
    {
      title: '保存价格参数',
      status: '',
    },
    {
      title: '价格计算中，计算完成自动提交审核',
      status: '',
    },
  ],
  isPriceAdjustConfirmBtnLoading: false,
  hasRules: false,
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setIsPriceAdjustmentModalOpenAction':
      newstate.isPriceAdjustmentModalOpen = action.payload
      return newstate
    case 'setIsDefinitionAction':
      newstate.isDefinition = action.payload
      return newstate
    case 'setSubmitApplyFlagAction':
      newstate.submitApplyFlag = action.payload
      return newstate
    case 'setCurrentStepAction':
      newstate.currentStep = action.payload
      return newstate
    case 'setCurrentApplyProductMainInfoAction':
      newstate.currentApplyProductMainInfo = action.payload
      return newstate
    case 'setProgressListAction':
      newstate.progressList = action.payload
      return newstate
    case 'setIsPriceAdjustConfirmBtnLoadingAction':
      newstate.isPriceAdjustConfirmBtnLoading = action.payload
      return newstate
    case 'setHasRulesAction':
      newstate.hasRules = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

// 设置表格数据
export const setDataSourceAction = (param: {
  dataSource: {
    data: GwProductItem[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})

// 调价弹框显隐
export const setIsPriceAdjustmentModalOpenAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsPriceAdjustmentModalOpenAction',
  payload: param,
})

// 是否为自定义调价
export const setIsDefinitionAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsDefinitionAction',
  payload: param,
})

// 是否展示提交申请步骤条页面
export const setSubmitApplyFlagAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setSubmitApplyFlagAction',
  payload: param,
})

// 设置步骤条当前位置
export const setCurrentStepAction = (param: number): CustomAction<Action> => ({
  type: 'setCurrentStepAction',
  payload: param,
})

// 当前物料主要信息-回显至调价弹窗
export const setCurrentApplyProductMainInfoAction = (
  param: CurrentProduct,
): CustomAction<Action> => ({
  type: 'setCurrentApplyProductMainInfoAction',
  payload: param,
})

// 当前步骤条数据
export const setProgressListAction = (
  param: ProgressItem[],
): CustomAction<Action> => ({
  type: 'setProgressListAction',
  payload: param,
})

// 弹窗提交按钮状态
export const setIsPriceAdjustConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsPriceAdjustConfirmBtnLoadingAction',
  payload: param,
})

export const setHasRulesAction = (param: boolean): CustomAction<Action> => ({
  type: 'setHasRulesAction',
  payload: param,
})
/*
 * @Descripttion: 官网物料调价页面相关数据
 * @Author: 曹博
 * @Date: 2023-10-24 09:33:27
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-03 09:17:45
 */

import { GwProductItem } from '../../api/InventoryManagementApi'
import { ActionType, CustomAction } from '../../global'

// 当前执行调价操作的物料
export interface CurrentProduct {
  id: string
  code: string
  name: string
  brandName: string
  manuCode: string
  gwProductSerialNumber: string
  orderRate: string
  highestChangePrice: string
}

// 进度条状态数据
export const progressItemStatusList = [
  {
    state: 'loading', // 当前步骤所对应的接口正在请求中
    des: '进行中...',
    color: '#FF7401',
  },
  {
    state: 'error',
    des: '失败，请关闭弹窗后重试', // 接口请求报错
    color: '#F5222D',
  },
  {
    state: '', // 接口请求成功/未执行到该步骤，不展示标签
    des: '',
    color: '',
  },
] as const
export type ProgressItemStatus =
  (typeof progressItemStatusList)[number]['state']
// 进度条数据类型
export interface ProgressItem {
  title: string
  status: ProgressItemStatus
}

export interface State {
  dataSource: {
    data: GwProductItem[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
  isPriceAdjustmentModalOpen: boolean // 调价弹窗显隐
  isDefinition: boolean // 是否为自定义调价
  submitApplyFlag: boolean // 是否展示步骤条结果页
  currentStep: number // 当前所处步骤
  currentApplyProductMainInfo: CurrentProduct // 当前调价物料
  progressList: ProgressItem[] // 步骤条数据
  isPriceAdjustConfirmBtnLoading: boolean // 弹窗提交按钮loading状态
  hasRules: boolean
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 0,
  },
  loading: true,
  searchData: {},
  pages: {
    pageNo: 1,
    pageSize: 10,
  },
  isPriceAdjustmentModalOpen: false,
  isDefinition: false,
  submitApplyFlag: false,
  currentStep: 0,
  currentApplyProductMainInfo: {
    id: '',
    code: '',
    name: '',
    brandName: '',
    manuCode: '',
    gwProductSerialNumber: '',
    orderRate: '',
    highestChangePrice: '',
  },
  progressList: [
    {
      title: '获取价格参数',
      status: 'loading',
    },
    {
      title: '保存价格参数',
      status: '',
    },
    {
      title: '价格计算中，计算完成自动提交审核',
      status: '',
    },
  ],
  isPriceAdjustConfirmBtnLoading: false,
  hasRules: false,
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setIsPriceAdjustmentModalOpenAction':
      newstate.isPriceAdjustmentModalOpen = action.payload
      return newstate
    case 'setIsDefinitionAction':
      newstate.isDefinition = action.payload
      return newstate
    case 'setSubmitApplyFlagAction':
      newstate.submitApplyFlag = action.payload
      return newstate
    case 'setCurrentStepAction':
      newstate.currentStep = action.payload
      return newstate
    case 'setCurrentApplyProductMainInfoAction':
      newstate.currentApplyProductMainInfo = action.payload
      return newstate
    case 'setProgressListAction':
      newstate.progressList = action.payload
      return newstate
    case 'setIsPriceAdjustConfirmBtnLoadingAction':
      newstate.isPriceAdjustConfirmBtnLoading = action.payload
      return newstate
    case 'setHasRulesAction':
      newstate.hasRules = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

// 设置表格数据
export const setDataSourceAction = (param: {
  dataSource: {
    data: GwProductItem[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})

// 调价弹框显隐
export const setIsPriceAdjustmentModalOpenAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsPriceAdjustmentModalOpenAction',
  payload: param,
})

// 是否为自定义调价
export const setIsDefinitionAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsDefinitionAction',
  payload: param,
})

// 是否展示提交申请步骤条页面
export const setSubmitApplyFlagAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setSubmitApplyFlagAction',
  payload: param,
})

// 设置步骤条当前位置
export const setCurrentStepAction = (param: number): CustomAction<Action> => ({
  type: 'setCurrentStepAction',
  payload: param,
})

// 当前物料主要信息-回显至调价弹窗
export const setCurrentApplyProductMainInfoAction = (
  param: CurrentProduct,
): CustomAction<Action> => ({
  type: 'setCurrentApplyProductMainInfoAction',
  payload: param,
})

// 当前步骤条数据
export const setProgressListAction = (
  param: ProgressItem[],
): CustomAction<Action> => ({
  type: 'setProgressListAction',
  payload: param,
})

// 弹窗提交按钮状态
export const setIsPriceAdjustConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsPriceAdjustConfirmBtnLoadingAction',
  payload: param,
})

export const setHasRulesAction = (param: boolean): CustomAction<Action> => ({
  type: 'setHasRulesAction',
  payload: param,
})
